import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/employeeManagement'

const employeeManagement = axios.create({
  baseURL
})

interceptorsSetup(employeeManagement)

export default class EmployeeManagement {
  static async getTable (employeeQuery) {
    const result = await employeeManagement.get('/' + employeeQuery.siteId, {})
    return result.data
  }
  static async createEmployee (employee) {
    const result = await employeeManagement.post('/', employee)
    return result.data
  }
  static async updateEmployee (employee) {
    const result = await employeeManagement.post('/update', employee)
    return result.data
  }
  static async archiveEmployee (employee) {
    const result = await employeeManagement.put('/archive/' + employee)
    return result.data
  }
}
